import * as React from 'react';

export function PictureInPicture(props: any) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M20 4H4C2.34315 4 1 5.34315 1 7V17C1 18.6569 2.34315 20 4 20H20C21.6569 20 23 18.6569 23 17V7C23 5.34315 21.6569 4 20 4Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 11H13C12.4477 11 12 11.4477 12 12V16C12 16.5523 12.4477 17 13 17H19C19.5523 17 20 16.5523 20 16V12C20 11.4477 19.5523 11 19 11Z"
        fill="currentColor"
      />
    </svg>
  );
}
